"use strict";
// @ts-ignore
try {
    self['workbox:window:5.0.0'] && _();
}
catch (e) { }
